export default "__VITE_ASSET__CWgB$GXA__"